import { render } from "./ai-grid-composition.vue?vue&type=template&id=4988a296"
import script from "./ai-grid-composition.vue?vue&type=script&lang=js"
export * from "./ai-grid-composition.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/demo/ai-grid-composition.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4988a296"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4988a296', __exports__)) {
    api.reload('4988a296', __exports__)
  }
  
  module.hot.accept("./ai-grid-composition.vue?vue&type=template&id=4988a296", () => {
    api.rerender('4988a296', render)
  })

}


export default __exports__